import { useContext } from 'react';
import { AutoSuggestContext } from '../contexts/AutoSuggestContext/AutoSuggestContext';
import { type IAutoSuggestParamsContextShape } from '../types/autoSuggestTypes';

// A custom hook allows us to test better.
export const useAutoSuggestParamsContext = (): IAutoSuggestParamsContextShape => useContext(AutoSuggestContext) as IAutoSuggestParamsContextShape;

export default useAutoSuggestParamsContext;
